import React, { useState, useEffect } from "react";
import chingu from "../../assets/images/Chingu.png";
import teko from "../../assets/images/teko.png";
import mistakes from "../../assets/images/mistakes.png";
import webflow from "../../assets/images/webflow.webp";
import left from "../../assets/icons/left.png";
import right from "../../assets/icons/right.png";
import "./Experience.css";

const experiences = [
  {
    image: webflow,
    jobTitle: "Web Integrator (Webflow) at Resume-Examples",
    content:
      "Contributed to migrating company blogs from WordPress to Webflow, handling multilingual integration, SEO optimization, and issue resolution. Worked with developers and automation teams, writing custom scripts in Webflow’s custom code section to enhance functionality and performance.",
    background: "#1a1a2ee6", 
    bannerColor: "#3b82f6",
  },
  {
    image: chingu,
    jobTitle: "React Developer Intern & Team Lead at Chingu",
    content:
      "Led a remote team while building the frontend with React, supported backend tasks using Node.js and MongoDB, and managed sprints and backlogs in JIRA.",
    background: "#4bc7b0", // green
    bannerColor: "#059669", // dark green
  },
  {
    image: teko,
    jobTitle: "Web Developer Intern at Teko",
    content:
      "Integrated UI mockups and customer charts, customized existing PrestaShop plugins, and contributed to a web application built with Symfony.",
    background: "#ee9e48", // orange
    bannerColor: "#d66022", // dark orange
  },
  {
    image: mistakes,
    jobTitle: "Learning Through Practice & Mistakes",
    content:
      "Hands-on coding practice and learning from mistakes have significantly strengthened my debugging skills.",
    background: "#5078d6", // blue
    bannerColor: "#173b88", // dark blue
  },
];

const Experience = () => {

  const [index, setIndex] = useState(0);

  // Preload all images once when component mounts
  useEffect(() => {
    experiences.forEach((exp) => {
      const img = new Image();
      img.src = exp.image;
    });
  }, []);

  const prevSlide = () => {
    setIndex((prev) => (prev - 1 + experiences.length) % experiences.length);
  };

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % experiences.length);
  };

  const { image, jobTitle, content, background, bannerColor } = experiences[index];

  return (
    <section className="experience-section" style={{ background: background }}>
      <h2 className="experience-heading">Where I’ve Gained Experience</h2>
      <div className="experience-layout">
        <div className="experience-card">
          <div className="experience-image">
            <img src={image} alt="Experience" />
          </div>
          <div className="experience-content" style={{ backgroundColor: bannerColor }}>
            <h2>{jobTitle}</h2>
            <p>{content}</p>
          </div>
          <button className="nav-btn left" onClick={prevSlide}>
            <img src={left} alt="Previous" />
          </button>
          <button className="nav-btn right" onClick={nextSlide}>
            <img src={right} alt="Next" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Experience;